/* esm.sh - qrcode.react@4.2.0 */
export * from "/*qrcode.react@4.2.0/esnext/qrcode.react.mjs";
